import axios from 'axios';
import { getUserToken } from '../common/resubale-functions';
import { baseURL } from '../common/constants';
const userToken = getUserToken();

const createClient = () => {
  const client = axios.create({
    baseURL,
    withCredentials: true,
  });

  return client;
};
const http = createClient();

export default http;

const createClientWithoutHeaders = () => {
  const clientIwthoutHeader = axios.create({
    baseURL,
    withCredentials: true,
  });

  return clientIwthoutHeader;
};
export const httpWithoutHeaders = createClientWithoutHeaders();
